import type { APIKey, APIKeyApi, PricingApi, Tenant } from '../../type';

export const API_KEY_KEYS = {
  get: (id?: APIKey['id']) =>
    id ? (['apiKeyApi.get', id] as const) : (['apiKeyApi.get'] as const),
  getCount: (param?: APIKeyApi.GetCount.Request) =>
    param
      ? (['apiKeyApi.getCount', JSON.stringify(param)] as const)
      : (['apiKeyApi.getCount'] as const),
  getList: (param?: APIKeyApi.GetList.Request) =>
    param
      ? (['apiKeyApi.getList', JSON.stringify(param)] as const)
      : (['apiKeyApi.getList'] as const),
};

export const PRICING_KEYS = {
  getPackageList: () => ['pricingApi.getPackageList'] as const,
  getOrderList: (
    tenantID?: Tenant['tenantID'],
    filter?: PricingApi.GetOrderList.Request,
  ) =>
    tenantID
      ? filter
        ? (['pricingApi.getOrderList', tenantID, filter] as const)
        : (['pricingApi.getOrderList', tenantID] as const)
      : (['pricingApi.getOrderList'] as const),
  /**
   * 주문 내역 무한 조회 전용 키입니다. 단건 목록 조회와 캐시 데이터 모양이 달라
   * 'infinite' 구분자를 덧붙이며, 접두사는 같아 기존 무효화 호출과 계속 매칭됩니다.
   */
  getInfiniteOrderList: (
    tenantID: Tenant['tenantID'] | undefined,
    filter: Omit<PricingApi.GetOrderList.Request, 'cursor'>,
  ) => ['pricingApi.getOrderList', tenantID, filter, 'infinite'] as const,
};
